const UMS_API_HOST = window.REACT_APP_KALGERA_UMS_API_HOST

const getFullUrl = path => UMS_API_HOST + path

export const routes = {
  get_clients: { method: 'GET', url: getFullUrl('/clients') },
  add_new_clients: { method: 'POST', url: getFullUrl('/clients') },
  delete_token: { method: 'DELETE', url: getFullUrl('/clients/:id') }
}
